import angular from 'angular'

import dispatch from './dispatch/dispatch.module'
import owners from './owners/owners.module'
import rails from './rails/rails.module'
import scrapping from './scrapping/scrapping.module'
import trains from './trains/trains.module'
import autocomplete from './autocomplete/autocomplete.module'
import commande from './commande/commande.module'

import entities from './entities.service'

const name = 'entities'

angular.module(name, [dispatch, owners, rails, scrapping, trains, autocomplete, commande,])
  .factory('entities', entities)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/entities.module.js